import { CONTEXT_KEY_SEPARATOR } from '../constants';
import type { ContextKeyInput } from '../types';

/**
 * Identifies an evaluation context by the parts LaunchDarkly targets on, so a
 * consumer can tell whether the answer it is reading describes the context it
 * is asking about.
 *
 * Display names are deliberately left out. They arrive from a later lookup and
 * cannot change how any flag evaluates, so keying on them would reopen the
 * identification wait — and a gated route's loading state — for an update that
 * cannot alter the answer.
 */
const buildContextKey = ({
  userId,
  selectedRegion,
  selectedCropSeason
}: ContextKeyInput): string =>
  [userId, selectedRegion ?? '', selectedCropSeason ?? ''].join(
    CONTEXT_KEY_SEPARATOR
  );

export default buildContextKey;
